import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _isLoading = signal<boolean>(false);
  readonly isLoading = computed<boolean>(() => this._isLoading());

  show(data: boolean) {
    this._isLoading.set(data);
  }
}
